/* ZERNO-BUILD: v11-b1 */
/* ZERNO product page — gallery, size variants, add-on, prices.
   Self-contained. No theme dependencies beyond window.theme.routes. */
(function () {
  'use strict';

  function money(cents) {
    var t = window.theme;
    if (t && typeof t.formatMoney === 'function' && t.moneyFormat) {
      try {
        return t.formatMoney(
          cents,
          t.settings && t.settings.currency_code_enable ? t.moneyWithCurrencyFormat : t.moneyFormat
        );
      } catch (e) { /* fall through */ }
    }
    var n = (cents || 0) / 100;
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }

  function init(root) {
    if (!root || root.__zpd) return;
    root.__zpd = true;

    var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
    var addonPrice = 0;
    var addonId = '';
                var addonName = '';
    var popTimer = null;

    var priceEl = root.querySelector('[data-zpd-price]');
    var quarters = root.querySelectorAll('[data-zpd-quarter]');
    var setp = root.querySelector('[data-zpd-setp]');
    var setv = root.querySelector('[data-zpd-setv]');
    var idInput = root.querySelector('[data-zpd-id]');
    var atc = root.querySelector('[data-zpd-atc]');

    function paint() {
      var total = basePrice + addonPrice;
      if (priceEl) priceEl.textContent = money(basePrice);
      for (var i = 0; i < quarters.length; i++) quarters[i].textContent = money(Math.round(total / 4));
      if (setp) {
        if (addonPrice > 0) {
          setp.removeAttribute('hidden');
          if (setv) setv.textContent = money(total);
        } else {
          setp.setAttribute('hidden', '');
        }
      }
    }

    /* ---------- gallery: dots follow the swipe ---------- */
    var gal = root.querySelector('[data-zpd-gal]');
    var dotsWrap = root.querySelector('[data-zpd-dots]');
    if (gal && dotsWrap) {
      var dots = dotsWrap.querySelectorAll('i');
      var lastDot = -1, ticking = false;
      var thumbs = root.querySelectorAll('[data-zpd-thumb]');
      var thumbWrap = root.querySelector('[data-zpd-thumbs]');

      function markActive(i) {
        if (i === lastDot) return;
        lastDot = i;
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
        for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-on', t === i);
        var el = thumbs[i];
        if (!el || !thumbWrap) return;
        var railW = thumbWrap.clientWidth;
        var max = thumbWrap.scrollWidth - railW;
        if (max <= 0) return;
        var target = el.offsetLeft - railW / 2 + el.offsetWidth / 2;
        thumbWrap.scrollTo({left: Math.max(0, Math.min(target, max)), behavior: 'smooth'});
      }

      gal.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = gal.clientWidth;
          if (w) markActive(Math.round(gal.scrollLeft / w));
        });
      }, {passive: true});

      for (var tk = 0; tk < thumbs.length; tk++) {
        (function (idx) {
          thumbs[idx].addEventListener('click', function () {
            gal.scrollTo({left: gal.clientWidth * idx, behavior: 'smooth'});
          });
        })(tk);
      }
    }

    /* ---------- variant options ----------
       Resolves the variant from the WHOLE option combination, so a product with
       more than one option works. The old code matched a single option by name
       and, on a product whose options are "Material" and "Option" (the
       pendants), matched nothing and silently shipped the default variant. */
    var variants = [];
    try {
      var vNode = root.querySelector('[data-zpd-variants]');
      if (vNode) variants = JSON.parse(vNode.textContent);
    } catch (e) { variants = []; }

    var optRows = root.querySelectorAll('[data-zpd-optrow]');
    var optPills = root.querySelectorAll('[data-zpd-opt]');
    var stSize = root.querySelector('[data-zpd-stsize]');
    var stIdx = stSize ? parseInt(stSize.getAttribute('data-zpd-stsize-idx'), 10) : -1;
    var atcLabel = (atc && atc.getAttribute('data-zpd-atc-label')) || 'Add to cart';

    var sel = [];
    for (var r0 = 0; r0 < optRows.length; r0++) {
      var i0 = parseInt(optRows[r0].getAttribute('data-zpd-optrow'), 10);
      var on0 = optRows[r0].querySelector('.zpd__pill.is-on');
      sel[i0] = on0 ? on0.getAttribute('data-zpd-optvalue') : null;
    }

    function findVariant(s) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < s.length; j++) {
          if (s[j] != null && v.o[j] !== s[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* is this value reachable given what is chosen in the OTHER rows? */
    function valueAvailable(idx, val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.a || v.o[idx] !== val) continue;
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (j !== idx && sel[j] != null && v.o[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function syncOptions() {
      for (var i = 0; i < optPills.length; i++) {
        var p = optPills[i];
        var idx = parseInt(p.getAttribute('data-zpd-opt'), 10);
        var val = p.getAttribute('data-zpd-optvalue');
        p.classList.toggle('is-on', sel[idx] === val);
        /* struck through but still clickable, so a shopper can move between
           combinations instead of hitting a dead end */
        p.classList.toggle('is-out', !valueAvailable(idx, val));
      }
      for (var q = 0; q < optRows.length; q++) {
        var ri = parseInt(optRows[q].getAttribute('data-zpd-optrow'), 10);
        var lbl = root.querySelector('[data-zpd-optval="' + ri + '"]');
        if (lbl) lbl.textContent = sel[ri] || '';
      }
      if (stSize && stIdx >= 0 && sel[stIdx] != null && stSize.value !== sel[stIdx]) {
        stSize.value = sel[stIdx];
      }
    }

    function applyVariant() {
      var v = findVariant(sel);
      if (v) {
        if (idInput) idInput.value = v.id;
        basePrice = v.p;
        if (atc) { atc.disabled = !v.a; atc.textContent = v.a ? atcLabel : 'Sold out'; }
        if (stBtn) { stBtn.disabled = !v.a; stBtn.textContent = v.a ? atcLabel : 'Sold out'; }
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      } else {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        if (stBtn) { stBtn.disabled = true; stBtn.textContent = 'Unavailable'; }
      }
      paint();
    }

    function selectOption(idx, val) {
      if (isNaN(idx) || val == null) return;
      sel[idx] = val;
      syncOptions();
      applyVariant();
    }

    for (var op = 0; op < optPills.length; op++) {
      (function (p) {
        p.addEventListener('click', function () {
          selectOption(parseInt(p.getAttribute('data-zpd-opt'), 10), p.getAttribute('data-zpd-optvalue'));
        });
      })(optPills[op]);
    }

    if (stSize) {
      stSize.addEventListener('change', function () { selectOption(stIdx, this.value); });
    }

    /* ---------- add-on ----------
       Clicking the selected add-on again clears it, back to the "…only" card,
       so you no longer have to scroll the rail back to the start to undo. */
    var addon = root.querySelector('[data-zpd-addon]');
    if (addon) {
      var cards = addon.querySelectorAll('[data-zpd-addon-card]');
      var noneCard = addon.querySelector('[data-addon-none]') || cards[0];

      function applyCard(card) {
        for (var c = 0; c < cards.length; c++) {
          var on = cards[c] === card;
          cards[c].classList.toggle('is-on', on);
          var t = cards[c].querySelector('[data-zpd-addon-toggle]') || cards[c];
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        addonId = card.getAttribute('data-addon-id') || '';
        addonPrice = parseInt(card.getAttribute('data-addon-price'), 10) || 0;
                addonName = card.getAttribute('data-addon-title') || '';
        paint();
        /* Show the bar on the tap itself and flash the new total, instead of
           waiting for the next scroll. Both are declared further down, so
           both are guarded. */
        if (syncSticky) syncSticky();
        popSticky();
      }

      addon.addEventListener('click', function (e) {
        var card = e.target.closest('[data-zpd-addon-card]');
        if (!card || !addon.contains(card)) return;

        /* colour chip: switch which variant this card represents. Picking a
           colour also selects the card — it must never toggle it back off. */
        var sw = e.target.closest('[data-zpd-addon-swatch]');
        if (sw) {
          var chips = card.querySelectorAll('[data-zpd-addon-swatch]');
          for (var k = 0; k < chips.length; k++) {
            var isOn = chips[k] === sw;
            chips[k].classList.toggle('is-on', isOn);
            chips[k].setAttribute('aria-pressed', isOn ? 'true' : 'false');
          }
          card.setAttribute('data-addon-id', sw.getAttribute('data-v') || '');
          card.setAttribute('data-addon-price', sw.getAttribute('data-p') || '0');
          var pr = card.querySelector('.zpd__ap');
          if (pr) pr.textContent = '+' + money(parseInt(sw.getAttribute('data-p'), 10) || 0);
          applyCard(card);
          return;
        }

        var isSelected = card.classList.contains('is-on');
        var isNone = !card.getAttribute('data-addon-id');
        if (isSelected && !isNone) card = noneCard;
        if (!card) return;
        applyCard(card);
      });
    }

    /* ---------- submit: chain, then bracelet, then open the drawer ---------- */
    var form = root.querySelector('[data-zpd-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc && atc.disabled) return;

        var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
        var items = [{id: idInput.value, quantity: 1}];
        if (addonId) items.push({id: addonId, quantity: 1});

        if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }

        fetch(url + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: items})
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
            document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles: true}));
          })
          .catch(function () { window.location = '/cart'; })
          .then(function () {
            if (atc) { atc.disabled = false; atc.classList.remove('is-loading'); }
          });
      });
    }

    /* ---------- sticky bar ----------
       Fixed to the viewport, so it survives past this section and stays for
       the rest of the page. Revealed once the real Add to cart scrolls above
       the fold, hidden again when you scroll back up to it. */
    var stPrice = root.querySelector('[data-zpd-stprice]');
    var stBtn = root.querySelector('[data-zpd-stbtn]');
    var sticky = root.querySelector('[data-zpd-sticky]');
    if (stBtn && form) {
      stBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
      });
    }
      /* Flash the price and the count. The bar is often already up by the time
       the rail is reached, so a silent recalculation reads as nothing having
       happened — the reveal alone cannot carry the feedback. */
    function popSticky() {
      if (!sticky) return;
      sticky.classList.remove('is-pop');
      void sticky.offsetWidth;              /* reflow, so the animation restarts */
      sticky.classList.add('is-pop');
      clearTimeout(popTimer);
      popTimer = setTimeout(function () { sticky.classList.remove('is-pop'); }, 600);
    }

    if (sticky && atc) {
           var stTicking = false;

      /* Direction-driven: down reveals, up hides.
         ST_MIN keeps it away at the very top, where the real Add to cart is
         still right there. ST_STEP swallows sub-pixel jitter and iOS momentum
         noise, which otherwise flip the bar on every frame. */
      var ST_MIN = 120;
      var ST_STEP = 6;
      var stLastY = window.pageYOffset || 0;
      var stDown = false;
      var syncSticky = function () {
        /* show once the real button has scrolled above the fold, and keep it
           for the rest of the page — it is fixed, not sticky, so nothing
           clips it when this section ends */
        var y = window.pageYOffset || 0;
        var dy = y - stLastY;
        /* Only commit to a direction on a real move, and only move the
           reference point then, so a slow drag still accumulates to a flip
           instead of being swallowed one pixel at a time. */
        if (dy > ST_STEP) { stDown = true; stLastY = y; }
        else if (dy < -ST_STEP) { stDown = false; stLastY = y; }

        sticky.classList.toggle('is-on', (stDown && y > ST_MIN) || addonId !== '');
      };
      var onScroll = function () {
        if (stTicking) return;
        stTicking = true;
        requestAnimationFrame(function () { stTicking = false; syncSticky(); });
      };
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll, {passive: true});
      syncSticky();
    }

    /* ---------- rail arrows (desktop) ---------- */
    root.querySelectorAll('[data-zpd-rw]').forEach(function (rw) {
      var rail = rw.querySelector('[data-zpd-rail]');
      var arws = rw.querySelectorAll('[data-zpd-arw]');
      if (!rail || !arws.length) return;

      function step() {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + 10 : 160;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        arws.forEach(function (a) {
          var dir = parseInt(a.getAttribute('data-zpd-arw'), 10);
          var atEnd = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
          if (max <= 2 || atEnd) a.setAttribute('disabled', '');
          else a.removeAttribute('disabled');
        });
      }
      arws.forEach(function (a) {
        a.addEventListener('click', function () {
          rail.scrollBy({left: parseInt(a.getAttribute('data-zpd-arw'), 10) * step(), behavior: 'smooth'});
        });
      });
      rail.addEventListener('scroll', sync, {passive: true});
      window.addEventListener('resize', sync, {passive: true});
      sync();
      setTimeout(sync, 200);
    });

    /* ---------- quick add from the stack rail ---------- */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-zpd-quick]');
      if (!q || !root.contains(q)) return;
      e.preventDefault();
      var vid = q.getAttribute('data-zpd-quick');
      if (!vid) return;
      var label = q.textContent;
      q.textContent = 'Adding...';
      q.disabled = true;
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      fetch(url + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: vid, quantity: 1}]})
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles: true}));
        })
        .catch(function () {})
        .then(function () { q.textContent = label; q.disabled = false; });
    });

        var stAdd = root.querySelector('[data-zpd-stadd]');
    var stBadge = root.querySelector('[data-zpd-stbadge]');
    var origPaint = paint;
    paint = function () {
      origPaint();
      if (stPrice) stPrice.textContent = money(basePrice + addonPrice);
      var extras = addonId ? 1 : 0;
      if (stBadge) {
        if (extras > 0) { stBadge.textContent = String(1 + extras); stBadge.removeAttribute('hidden'); }
        else { stBadge.setAttribute('hidden', ''); }
      }
      if (stAdd) {
        if (extras > 0) { stAdd.textContent = '+' + extras + (extras === 1 ? ' item' : ' items'); stAdd.removeAttribute('hidden'); }
        else { stAdd.setAttribute('hidden', ''); }
      }
    };

    /* run last: applyVariant touches stBtn, which is assigned further up only
       after the options block, and it calls paint() itself */
    syncOptions();
    applyVariant();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-zerno-product]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
